import { Routes, Route } from "react-router-dom";
import { AnnouncementBar } from "@/components/layout/AnnouncementBar";
import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { ScrollToTop } from "@/components/layout/ScrollToTop";
import { HomePage } from "@/pages/Home";
import { VpsHostingPage } from "@/pages/VpsHosting";
import { DedicatedServersPage } from "@/pages/DedicatedServers";
import { CloudSolutionsPage } from "@/pages/CloudSolutions";
import { EmailSolutionsPage } from "@/pages/EmailSolutions";
import { SecurityNetworkPage } from "@/pages/SecurityNetwork";
import { AboutPage } from "@/pages/About";
import { ContactPage } from "@/pages/Contact";
import { SupportPage } from "@/pages/Support";
import { LegalPage } from "@/pages/Legal";
import { NotFoundPage } from "@/pages/NotFound";

export default function App() {
  return (
    <>
      <ScrollToTop />
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-[100] focus:bg-navy-card focus:text-text-primary focus:px-4 focus:py-2 focus:rounded-md"
      >
        Skip to content
      </a>
      <AnnouncementBar />
      <Header />
      <main id="main-content">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/vps-hosting" element={<VpsHostingPage />} />
          <Route path="/dedicated-servers" element={<DedicatedServersPage />} />
          <Route path="/cloud-solutions" element={<CloudSolutionsPage />} />
          <Route path="/email-solutions" element={<EmailSolutionsPage />} />
          <Route path="/security-network" element={<SecurityNetworkPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/support" element={<SupportPage />} />
          <Route path="/legal/:slug" element={<LegalPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </main>
      <Footer />
    </>
  );
}
